import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from 'react-router-dom'
import Profile from '../pages/Profile/Profile'
import Brief from '../pages/Brief/Brief'

const BriefRouter = () => (
  <Router>
    <Switch>
      <Route path="/brief" component={Brief} />
      <Route path="/profile" component={Profile} />
      <Redirect to="/brief" />
    </Switch>
  </Router>
)

export default BriefRouter
